export const CONTAINER_MAX_WIDTH = 'xl'